import req from "../http";

const defaultMessage = {
  // 取得 階層
  getHierarchy(num) {
    return req("get", `/BasicInformation/DefaultMessage/MessageTypes/${num}`);
  },

  // 取得 罐頭訊息清單
  getCannedLetterList(messageType) {
    return req("get", `/BasicInformation/DefaultMessage/List/${messageType}`);
  },

  // 新增 罐頭訊息
  postDefaultMessage(params) {
    return req("post", "/BasicInformation/DefaultMessage", params);
  },

  // 更新 罐頭訊息
  putDefaultMessage(params) {
    return req("put", "/BasicInformation/DefaultMessage", params);
  },

  // 刪除 罐頭訊息
  delDefaultMessage(guid) {
    return req("delete", `/BasicInformation/DefaultMessage/${guid}`);
  },

  // 變更排序
  postSort(params) {
    return req("post", "/BasicInformation/DefaultMessage/Sort", params);
  }
};

export default defaultMessage;